import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import { Box, Button, Stack, Grid, FormControl, InputLabel, useMediaQuery } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { enIN } from 'date-fns/locale';
import LeadStore from '../../store/LeadStore';
import { isEmpty } from '../../utils/helper';

export const EditProjectTimeLineDetails = observer(({ leadId, details, handleEditDetails }) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const [formData, setFormData] = useState({
    id: details?.clientPackageAndPaymentId ?? null,
    leadId,
    toggleResidentialPackage: !isEmpty(details?.residentialPackage),
    residentialPackage: details?.residentialPackage,
    projectCode: details?.projectCode,
    signUpDate: details?.signUpDate,
    soilTestDate: details?.soilTestDate,
    totalStationDate: details?.totalStationDate,
    floorPlanFinalisedDate: details?.floorPlanFinalisedDate,
    elevationFinalisedDate: details?.elevationFinalisedDate,
    masterFileFinalisedDate: details?.masterFileFinalisedDate,
    tentativeCommencementDate: details?.tentativeCommencementDate,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleUpdateLeadKycSubmit = (e) => {
    e.preventDefault();
    const payload = { ...formData };
    isEmpty(formData.id) ? LeadStore.createPcpDetails(payload) : LeadStore.updatePcpDetails(payload);
  };

  useEffect(() => {
    LeadStore.updatePcpDetailsStatus && handleEditDetails();
  }, [LeadStore.updatePcpDetailsStatus, handleEditDetails]);

  return (
    <Paper sx={{ px: '30px', py: '20px', pb: '40px' }}>
      <Box component="form" noValidate autoComplete="off" onSubmit={handleUpdateLeadKycSubmit}>
        <Stack spacing={4}>
          <Grid container spacing={3}>
            {[
              { label: 'Sign up Date', name: 'signUpDate' },
              { label: 'Soil Test Date', name: 'soilTestDate' },
              { label: 'Total Station Date', name: 'totalStationDate' },
              {
                label: 'Floor Plan Finalised Date',
                name: 'floorPlanFinalisedDate',
              },
              {
                label: 'Elevation Finalised Date',
                name: 'elevationFinalisedDate',
              },
              {
                label: 'Master File Finalised Date',
                name: 'masterFileFinalisedDate',
              },
              {
                label: 'Tentative Commencement Date',
                name: 'tentativeCommencementDate',
              },
            ].map((field, index) => (
              <Grid item xs={12} sm={6} key={index}>
                <FormControl fullWidth margin="normal" variant="outlined">
                  <InputLabel shrink>{field.label}</InputLabel>
                  <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enIN}>
                    <DatePicker
                      variant="standard"
                      label=""
                      value={formData[field.name] ? new Date(formData[field.name]) : null}
                      onChange={(newValue) =>
                        handleChange({
                          target: { name: field.name, value: newValue },
                        })
                      }
                      renderInput={(params) => <params.InputComponent {...params.inputProps} variant="outlined" />}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
            ))}
          </Grid>
          <Stack direction="row" sx={{ ml: 'auto' }} alignSelf={isSmallScreen ? '' : 'end'} spacing={2}>
            <Button variant="outlined" color="inherit" size="small" onClick={() => handleEditDetails(false)}>
              Cancel
            </Button>
            <Button variant="contained" type="submit" size="small">
              Save
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Paper>
  );
});

export default EditProjectTimeLineDetails;
